// THIS IS THE CREATE UPDATED AND DELETE, AND QUERIES IS FOR READ
export const createTransaction = `
  mutation CreateTransaction($input: CreateTransactionInput!) {
    createTransaction(input: $input) {
      id
      full_name
      createdAt
      date_created
      date_released
      date_updated
      document_name
      updatedAt
      user_profile_id
      user_profile_photo
      transaction_status
      transaction_payment_status
      transaction_id
      released_by_id
      meeting_pass
      meeting_id
      document_price
      user_location {
        latitude
        longitude
      }
      transaction_type
      lawyer_id
      registration_id
      scheduled_at
      scheduled_status
      document_title
      negotiation_status
      TransactionMessagesRelation(sortDirection:ASC){
          items {
            transaction_id
            message
            id
            date_created
            createdAt
            chat_id
            updatedAt
            user_profile_id
          }
        }
      
    }
  }
`;



export const updateTransaction = `
  mutation UpdateTransaction(
  $input: UpdateTransactionInput!
  $condition: ModelTransactionConditionInput
  ) {
    updateTransaction(input: $input, condition: $condition) {
      id
      full_name
      createdAt
      date_created
      date_released
      date_updated
      document_name
      updatedAt
      user_profile_id
      user_profile_photo
      transaction_status
      transaction_payment_status
      transaction_id
      released_by_id
      meeting_pass
      meeting_id
      document_price
      user_location {
        latitude
        longitude
      }
      transaction_type
      lawyer_id
      registration_id
      scheduled_at
      scheduled_status
      document_title
      negotiation_status
      TransactionMessagesRelation(sortDirection:ASC){
          items {
            transaction_id
            message
            id
            date_created
            createdAt
            chat_id
            updatedAt
            user_profile_id
          }
        }
      
    }
  }
`;

export const deleteTransaction = `
  mutation DeleteTransaction($input: DeleteTransactionInput!) {
    deleteTransaction(input: $input) {
      id
      full_name
      createdAt
      date_created
      date_released
      date_updated
      document_name
      document_price
      updatedAt
      user_profile_id
      user_profile_photo
      transaction_status
      transaction_payment_status
      transaction_id
      released_by_id
      meeting_pass
      meeting_id
      user_location {
        latitude
        longitude
      }
      transaction_type
      lawyer_id
      registration_id
      scheduled_at
      scheduled_status
      document_title
      negotiation_status
      TransactionMessagesRelation(sortDirection:ASC){
          items {
            transaction_id
            message
            id
            date_created
            createdAt
            chat_id
            updatedAt
            user_profile_id
          }
        }
    
    }
  }
`;



export const createUserStatus = `
  mutation CreateUserStatus($input: CreateUserStatusInput!) {
     createUserStatus(input: $input) {
      id
      user_profile_id
      user_status
      full_name
      user_profile_photo
      user_location {
        latitude
        longitude
      }
    }
  }
`;


export const updateUserStatus = `
  mutation UpdateUserStatus($input: UpdateUserStatusInput!) {
    updateUserStatus(input: $input) {
      id
      user_profile_id
      user_status
      full_name
      user_profile_photo
      user_location {
        latitude
        longitude
      }
      createdAt
      updatedAt
    }
  }
`;


export const createTransactionLawyer = `
  mutation CreateTransactionLawyer($input: CreateTransactionLawyerInput!) {
     createTransactionLawyer(input: $input) {
        created_by
        user_profile_photo
        user_profile_id
        updated_by
        updatedAt
        transaction_type
        transaction_status
        transaction_id
        lawyer_name
        id
        document_status
        document_price
        date_updated
        date_created
        createdAt
        user_location {
          latitude
          longitude
        }
    }
  }
`;


export const updateTransactionLawyer = `
  mutation UpdateTransactionLawyer($input: UpdateTransactionLawyerInput!) {
    updateTransactionLawyer(input: $input) {
      createdAt
      created_by
      date_created
      date_updated
      document_price
      document_status
      id
      lawyer_name
      transaction_id
      transaction_status
      transaction_type
      updatedAt
      updated_by
      user_profile_id
      user_profile_photo
      user_location {
        latitude
        longitude
      }
    }
  }
`;

export const deleteTransactionLawyer = `
  mutation DeleteTransactionLawyer($input: DeleteTransactionLawyerInput!) {
    deleteTransactionLawyer(input: $input) {
      createdAt
      created_by
      date_created
      date_updated
      document_price
      document_status
      id
      lawyer_name
      transaction_id
      transaction_status
      transaction_type
      updatedAt
      updated_by
      user_profile_id
      user_profile_photo
      user_location {
        latitude
        longitude
      }
    }
  }
`;


// CHAT
export const createChatMessage = `
  mutation CreateChatMessage($input: CreateChatMessageInput!) {
    createChatMessage(input: $input) {
      id
      chat_id
      transaction_id
      user_profile_id
      message
      date_created
      createdAt
      updatedAt
    }
  }
`;



export const updateChatMessage = `
  mutation UpdateChatMessage($input: UpdateChatMessageInput!) {
    updateChatMessage(input: $input) {
      id
      chat_id
      transaction_id
      user_profile_id
      message
      date_created
      createdAt
      updatedAt
    }
  }
`;




export const deleteChatMessage = `
  mutation DeleteChatMessage(
  $input: DeleteChatMessageInput!
  $condition: ModelChatMessageConditionInput
  ) {
    deleteChatMessage(input: $input, condition: $condition) {
      id
      chat_id
      transaction_id
      user_profile_id
      message
      date_created
      createdAt
      updatedAt
    }
  }
`;



// CHAT NEGOTIATION NOT CHAT MESSAGE
export const createChatNegotiation = `
  mutation CreateChatNegotiation($input: CreateChatNegotiationInput!) {
    createChatNegotiation(input: $input) {
      id
      status
      lawyer_id
      transaction_id
      date_created
      createdAt
      updatedAt
    }
  }
`;

export const deleteChatNegotiation = `
  mutation DeleteChatNegotiation($input: DeleteChatNegotiationInput!) {
    deleteChatNegotiation(input: $input) {
      id
      status
      lawyer_id
      transaction_id
      date_created
      createdAt
      updatedAt
    }
  }
`;


export const updateChatNegotiation = `
  mutation UpdateChatNegotiation(
  $input: UpdateChatNegotiationInput!
  $condition: ModelChatNegotiationConditionInput

  ) {
    updateChatNegotiation(input: $input, condition: $condition) {
      id
      status
      lawyer_id
      transaction_id
      date_created
      createdAt
      updatedAt
    }
  }
`;



export const updateWitnessTransaction = `
  mutation UpdateWitnessTransaction(
  $input: UpdateWitnessTransactionInput!
  $condition: ModelWitnessTransactionConditionInput

  ) {
    updateWitnessTransaction(input: $input, condition: $condition) {
      id
      transaction_id
      contact_info
      participant_type
      signature
      created_by
      date_created
      date_updated
      updated_by
      transaction_status
      valid_id
      createdAt
      updatedAt
    }
  }
`;





export const updateTransactionVideoConference = `
  mutation UpdateTransactionVideoConference(
  $input: UpdateTransactionVideoConferenceInput!
  $condition: ModelTransactionVideoConferenceConditionInput

  ) {
    updateTransactionVideoConference(input: $input, condition: $condition) {
      id
      transaction_id
      user_id
      user_tag
      createdAt
      updatedAt
    }
  }
`;
